
export function getBrowserOs() {
  // if (navigator.platform.indexOf("iPhone") !== -1
  //   || navigator.platform.indexOf("iPad") !== -1
  //   || navigator.platform.indexOf('iPod') !== -1) {
  //   return 'ios';
  // }
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    return 'ios';
  } else if (/(Android)/i.test(navigator.userAgent)) {
    return 'android';
  } else if (/(Windows)/i.test(navigator.platform) || /(Win32)/i.test(navigator.platform)) {
    return 'windows';
  } else if (/(Mac68K)/i.test(navigator.platform) ||
    /(MacPPC)/i.test(navigator.platform) ||
    /(Macintosh)/i.test(navigator.platform) ||
    /(MacIntel)/i.test(navigator.platform)) {
    return 'mac';
  }
  return 'unknown';
}

export function  getSystemBit() {
  /*获取 Windows 操作系统位数 32位 or 64位*/
  if (getBrowserOs() !== 'windows') {
    return 'x64';
  }
  let x  = navigator.userAgent.match(/x86_64|Win64|WOW64/) ||navigator.cpuClass === 'x64' ? 'x64' : 'x86';
  return x;
}

export function formatOS(os) {
  switch (os) {
    case 'mac':
      return 'Mac';
    case 'windows':
      return 'Windows';
    case 'ios':
      return 'iOS';
    case 'android':
      return 'Android';
    default:
      return 'Unknown';
  }
}

export function isPC() {
    let userAgentInfo = navigator.userAgent;
    let Agents = [
      "Android",
      "iPhone",
      "SymbianOS",
      "Windows Phone",
      "iPad",
      "iPod",
      "phone",
      "pad",
      "pod",
      "ios",
      "Mobile",
      "BlackBerry",
      "IEMobile",
      "MQQBrowser",
      "JUC",
      "Fennec",
      "wOSBrowser",
      "BrowserNG",
      "WebOS",
      "Symbian"
    ];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;
}

export function isWeixin() {
  let ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/utils.js